import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Menu from './components/Menu'
import Brbtx from './components/Brbtx';
import Wbw from './components/Wbw';
import Pb from './components/Pb';
import { AppProvider } from './context/Context';
import Terms from './components/Terms';
import Home from './components/Home';
import c from './assets/config';

function App() {
  return (
    <AppProvider>
    <Router>
      <Routes>
        <Route path='/' element={<Menu />} >
            <Route path="/" index element={<Home />} /> 
            <Route path={"/"+c.pages[1]} index element={<Wbw />} />
            <Route path={"/"+c.pages[2]} element={<Pb />} />
            <Route path={"/"+c.pages[3]} element={<Terms />} />
            <Route path={"/"+c.pages[0]} element={<Brbtx />} />
        </Route>
      </Routes>
    </Router>
    </AppProvider>
  );
}

export default App;